
export const KEY__CREDENTIAL__PRIMARY = 'primary_credential';
export const KEY__CREDENTIAL__SECONDARY = 'secondary_credential';
export const KEY__CREDENTIAL__LOGIN = 'login_credential';
